import { useLocation, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../../components/Loading/Loading"; // Import trang loading
import { useLoading } from "../../context/Loading";
import BASE_URL from "../../configs/api";
import { toast } from "react-toastify";
import { getProxyUrl } from "../../utils/proxy";
import { FiHome, FiChevronRight, FiSearch } from "react-icons/fi";

const SearchMovies = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [phimCategory, setPhimCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const searchQuery = new URLSearchParams(location.search).get("q");

  useEffect(() => {
    const fetchSearchMovies = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/api/search/`, {
          params: { q: searchQuery },
        });
        setPhimCategory(response.data);
        if (response.data.results.length === 0) {
          toast.error(`Không tìm thấy phim với từ khóa: ${searchQuery}`);
        } else {
          toast.success("Phim đã được tìm thấy!");
        }
      } catch (error) {
        console.error("Lỗi khi gọi API:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSearchMovies();
  }, [searchQuery]);

  if (loading) {
    return <Loading />;
  }
  if (phimCategory.length === 0) {
    return (
      <div className="xl:container xl:mx-auto px-4 min-h-screen">
        <h2 className="text-xl xl:text-[1.5rem] font-medium text-white mb-7">
          Không tìm thấy phim với từ khóa: {searchQuery}
        </h2>
        <p className="text-white">Mời bạn thử lại với từ khóa khác.</p>
      </div>
    );
  }
  return (
    <div className="xl:container xl:mx-auto p-4 min-h-screen">
      <div className="p-3.5 rounded-lg mt-4 mb-4 w-full h-auto bg-[#2a2d42] bg-opacity-50">
        <nav className="text-sm text-white flex items-center flex-wrap gap-x-1.5">
          <Link
            to="/"
            className="hover:underline hover:text-orange-300 inline-flex items-center transition-colors duration-150"
          >
            <FiHome className="mr-1.5 w-4 h-4" />
            Trang chủ
          </Link>

          <FiChevronRight className="w-4 h-4 text-neutral-400" />

          <span className="text-orange-300 font-medium inline-flex items-center">
            <FiSearch className="mr-1.5 w-4 h-4" />

            <span className="ml-1 font-semibold">"{searchQuery}"</span>
          </span>
        </nav>
      </div>

      <div className="mb-6 md:mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        {/* <h1 className="text-xl lg:text-2xl text-neutral-100 font-bold inline-block border-b-2 border-orange-500  "></h1> */}
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-seogoe relative ">
          Kết Quả: {searchQuery}
          <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-orange-400 to-transparent rounded-full pb-1"></div>
        </h1>
        {phimCategory.count > 0 && (
          <span className="text-sm sm:text-base text-white/70 pt-4 sm:mt-0">
            Tìm thấy {phimCategory.count} phim
          </span>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6  xl:grid-cols-8 gap-4 md:gap-3">
        {phimCategory.map((movie) => (
          <div
            key={movie.slug}
            className="movie-card transition-transform duration-200 ease-in-out"
          >
            <div className="relative rounded-md overflow-hidden group">
              <Link to={`/phim/${movie.slug}`}>
                <div className="relative">
                  <img
                    src={movie.poster_url || getProxyUrl(movie.poster)}
                    alt={movie.ten_phim}
                    className="w-full h-auto aspect-[2/3] object-cover"
                  />
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-row justify-center items-start z-20">
                    <div className="bg-gradient-to-r from-gray-700 to-gray-600 text-white text-[10px] leading-tight md:text-xs font-semibold px-2 py-0.5 rounded-tl-[0.2rem] shadow-md whitespace-nowrap">
                      {movie.ngon_ngu
                        ? movie.ngon_ngu
                            .replace("Vietsub", "P.Đ")
                            .replace("Lồng Tiếng", "T.M")
                            .replace("Thuyết Minh", "T.M")
                        : "Đang cập nhật"}
                    </div>
                    <div className="bg-gradient-to-r from-[#C02425] to-[#fd9a05] text-white text-[10px] leading-tight md:text-xs font-semibold px-2 py-0.5 rounded-tr-[0.2rem] shadow-md whitespace-nowrap">
                      {(movie.tinh_trang || "Đang cập nhật")
                        .replace(/Hoàn Tất/gi, "HT")
                        .trim() || "Đang cập nhật"}
                    </div>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="bg-orange-500 rounded-full p-3 shadow-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M21.409 9.353a2.998 2.998 0 0 1 0 5.294L8.597 21.614C6.534 22.737 4 21.277 4 18.968V5.033c0-2.31 2.534-3.769 4.597-2.648z"
                        />
                      </svg>
                    </div>
                  </div>

                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-20 transition duration-300" />
                </div>
              </Link>
            </div>
            <div className="mt-2 text-center">
              <Link
                to={`/phim/${movie.slug}`}
                className="text-white text-sm font-medium truncate hover:text-yellow-200 cursor-pointer line-clamp-none"
                title={movie.ten_phim}
              >
                {movie.ten_phim}
              </Link>
              <p
                className="text-gray-400 text-xs truncate"
                title={movie.ten_khac}
              >
                {movie.ten_khac}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchMovies;
